import { render } from "./ProductInput.vue?vue&type=template&id=1730e952&scoped=true"
import script from "./ProductInput.vue?vue&type=script&lang=js"
export * from "./ProductInput.vue?vue&type=script&lang=js"

import "./ProductInput.vue?vue&type=style&index=0&id=1730e952&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1730e952"]])

export default __exports__